import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/SKO.png'
import _imports_1 from '@/assets/images/sko.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Северо-Казахстанская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Северо-Казахстанская область славится красотой своей природы. Это идеальное место для организации экологических туров. Наиболее распространен в регионе внутренний туризм, статистика также говорит о достаточном количестве приезжающих сюда с туристическими целями россиян, ведь СКО граничит с тремя областями России. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "«Зеленый» Туризм")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Экскурсии на природу в регионе пользуются большим успехом. Здесь есть и степи, и лесостепи, березовые и осиново-березовые леса, ивовые заросли, разнотравно-злаковые луговые просторы, осоковые болота. "),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Самая популярная местная дестинация, как утверждает статистика туризма Северо-Казахстанской области, это "),
          /*#__PURE__*/_createVNode("b", null, "озеро Имантау"),
          /*#__PURE__*/_createTextVNode(". Сюда организуют рыболовные туры, место подходит для пляжного отдыха, соседнее одноименное село – отличный объект для исторических экскурсий. А поправить здоровье лучше отправляться на воды озера Шалкар. Только в третьем квартале 2020 года "),
          /*#__PURE__*/_createVNode("b", null, "Имантауско-Шалкарскую курортную зону"),
          /*#__PURE__*/_createTextVNode(" посетило, согласно официальному сайту "),
          /*#__PURE__*/_createVNode("a", { href: "stat.gov.kz" }, " stat.gov.kz"),
          /*#__PURE__*/_createTextVNode(", 17963 туриста. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "5533")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "22,7")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "105831")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "11988")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Туры По Историческим Местам")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Иностранные туристы охотнее отправляются в экскурсии по исторически значимым местам Центральной Азии – так говорит статистика туризма Казахстана. В СКО перспективными направлениями являются организация туров к археологическому комплексу "),
          /*#__PURE__*/_createVNode("b", null, "«Бектениз»"),
          /*#__PURE__*/_createTextVNode(", состоящему из десяти курганов, популярны экскурсии в мемориальный комплекс "),
          /*#__PURE__*/_createVNode("b", null, "«Агынтай-батыра и Карасай-батыра»"),
          /*#__PURE__*/_createTextVNode(", участников казахско-джунгарской войны. Практически во все познавательные экскурсионные программы включается посещение "),
          /*#__PURE__*/_createVNode("b", null, "резиденции великого правителя Абылай-хана"),
          /*#__PURE__*/_createTextVNode(" в Петропавловске. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Другие Направления Туризма")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " В последние годы в Северно-Казахстанской области развиваются новые виды туристической деятельности. Научно-познавательные экскурсии организуются в Астрофизическую обсерваторию, работающую в Петропавловске на базе Северо-Казахстанского государственного университета им. М. Козыбаева. Здесь установлен второй по величине в стране телескоп с диаметром зеркала 0,77 м. В хорошую погоду он позволяет увидеть звездное небо даже днем. При обсерватории работает планетарий, предлагающий изображение звезд и созвездий с очень высокой детализацией. "),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Перспективны пешие экскурсии по региону с посещением необычных объектов. К примеру, многим казахстанцам наверняка будет интересно посетить окрестности села "),
          /*#__PURE__*/_createVNode("b", null, "Каратал"),
          /*#__PURE__*/_createTextVNode(" в Айыртауском районе. В 1963 году здесь приземлился космический аппарат «Восток-5». Его пилот – космонавт Валерий Быковский – стал рекордсменом, совершившим самый продолжительный в истории мировой одиночный полет в космос. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "regio-swiper" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}